import React, { useRef, useState } from 'react'
import useCustomStyles from '../../hooks/useCustomStyles'
// import { accessCodeFormStyles } from '../../assets/styles/accessCodeFormStyles'
import { useSelector } from 'react-redux'
import { selectState } from '../../store/slices/themeSlice'
// import { useLocation } from 'react-router-dom'

import { customStyles } from '../../assets/styles/customStyles'
// import { RootState } from '../../store/store'
import HeaderTabs from '../clients/components/HeaderTabs'
import { ReactComponent as Download } from '../../assets/images/Download.svg'
import QRCode from 'react-qr-code'

const ReferralCodeDetails: React.FC = () => {
  const { theme } = useSelector(selectState)

  const classes1 = useCustomStyles(customStyles, theme)

  const [selectedTab, setSelectedTab] = useState('code_details')
  const qrWrapperRef = useRef<HTMLDivElement | null>(null)
  ////NOTE: I'M USING STATIC QR CODE BASSAM
  const downloadQRCode = () => {
    if (qrWrapperRef.current) {
      // Find the SVG element inside the wrapper
      const svg = qrWrapperRef.current.querySelector('svg')
      if (svg) {
        const svgData = new XMLSerializer().serializeToString(svg)
        const svgBlob = new Blob([svgData], {
          type: 'image/svg+xml;charset=utf-8',
        })
        const url = URL.createObjectURL(svgBlob)

        // Create a download link
        const link = document.createElement('a')
        link.href = url
        link.download = `QR_Code_${'bassam'}.svg`
        document.body.appendChild(link)
        link.click()

        // Cleanup
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      }
    }
  }
  const tabs = [{ value: 'code_details', label: 'Code Details' }]
  const rows = [
    { label: 'Contract', value: 'contracte' },
    { label: 'Reference', value: 'Reference' },
    { label: 'Start Date', value: 'ZIM Connections' },
    { label: 'Expiry Date', value: '#1236789' },
    { label: 'Administrator', value: 'United Kingdom' },
    { label: 'Total Licences', value: 'English' },
  ]

  return (
    <div className={classes1.container}>
      <div className={classes1?.box}>
        <div className={classes1.tableContainer}>
          <h2 className={classes1.header}>REFERRAL CODE</h2>
        </div>
        <HeaderTabs
          tabs={tabs}
          selectedTab={selectedTab}
          onSelect={setSelectedTab}
        />
        {selectedTab === 'code_details' && (
          <div
            style={{
              borderRadius: '8px',
            }}
          >
            <div
              style={{
                background: '#fff',
                padding: 30,
                width: '90%',
              }}
            >
              <div
                style={{
                  // padding: "0px 10px",
                  minWidth: '50px',
                  maxWidth: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  overflowX: 'auto',
                }}
              >
                <table
                  style={{
                    width: '70%',
                    borderCollapse: 'collapse',
                    padding: '0px ',
                    height: 20,
                  }}
                >
                  <tbody>
                    {rows.map((row, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 1 ? '#fff' : ' #F6F6F6', // White for even, red for odd
                          // borderBottom: "1px solid #eee",
                          maxHeight: '10',
                        }}
                      >
                        <td
                          style={{
                            padding: '10px 15px',
                            fontWeight: 'bold',
                            color: '#777',
                            minWidth: '50%',
                            fontFamily: 'Gilroy-Regular',
                            fontSize: 18,
                            textAlign: 'left',
                            //   maxHeight: "10px",
                            verticalAlign: 'middle', // Align text vertically in the center
                          }}
                        >
                          {row.label}
                        </td>
                        <td
                          style={{
                            width: '50%',
                            padding: '10px 15px',
                            color: '#333',
                            fontFamily: 'Gilroy-Regular',
                            fontSize: 18,
                            fontWeight: '400',
                            textAlign: 'left',
                            //   maxHeight: "10px",
                            verticalAlign: 'middle', // Align text vertically in the center
                          }}
                        >
                          {row.value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div
                  style={{
                    display: 'flex', // Enable flexbox
                    flexDirection: 'column', // Stack children vertically
                    alignItems: 'center', // Center horizontally
                    justifyContent: 'center', // Center vertically
                    //   padding: 40,
                    //   background: "red",
                    width: '30%',
                    //   height: "300px", // Add height to center properly
                  }}
                >
                  <div ref={qrWrapperRef}>
                    <QRCode value={'bbb'} size={180} />
                  </div>
                  <div
                    //   className={`${classes1.flexCenter} ${classes1.linkUnderline}`}
                    onClick={downloadQRCode}
                    style={{
                      cursor: 'pointer',
                      border: '1px solid #6B7A8E',
                      borderRadius: 24,
                      padding: 4,
                      justifyContent: 'center',
                      margin: '10px 0px',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      width: 200,
                    }}
                  >
                    <div
                      style={{
                        marginRight: 10,
                      }}
                    >
                      <Download width={20} height={20} />
                    </div>
                    <p
                      style={{
                        fontSize: 14,
                        color: '#6B7A8E',
                        padding: '0px 4px',
                        fontFamily: 'Gilroy-Regular',
                      }}
                    >
                      Download QR Code
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ReferralCodeDetails
